var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84309 11.5C4.64397 11.1088 5.54598 10.8889 6.5 10.8889C7.45402 10.8889 8.35603 11.1088 9.15691 11.5M3.38 9.05556H9.62C10.6281 9.05556 11.1321 9.05556 11.5172 8.85573C11.8559 8.67997 12.1312 8.3995 12.3038 8.05454C12.5 7.66237 12.5 7.14899 12.5 6.12222V3.43333C12.5 2.40657 12.5 1.89319 12.3038 1.50102C12.1312 1.15605 11.8559 0.875589 11.5172 0.699821C11.1321 0.5 10.6281 0.5 9.62 0.5H3.38C2.37191 0.5 1.86786 0.5 1.48282 0.699821C1.14413 0.875589 0.86876 1.15605 0.696188 1.50102C0.5 1.89319 0.5 2.40657 0.5 3.43333V6.12222C0.5 7.14899 0.5 7.66237 0.696188 8.05454C0.86876 8.3995 1.14413 8.67997 1.48282 8.85573C1.86786 9.05556 2.37191 9.05556 3.38 9.05556Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDp);
export default __webpack_public_path__ + "static/media/dp.73f0f00cc077cf37859a2f51197affd3.svg";
export { ForwardRef as ReactComponent };